import { Components, menuItemClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiMenu to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/menu-item#css
 */
export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: '36px',
      padding: theme.spacing(1, 2),
      '&:hover': {
        backgroundColor: theme.palette.menu.item.hover,
      },
      [`&.${menuItemClasses.selected}`]: {
        backgroundColor: theme.featureFlags.panwRebrandStubYear
          ? `${theme.palette.menu.item.selected} !important`
          : theme.palette.menu.item.selected,
      },
    }),
  },
};
